import React, {Component, Fragment} from "react";
import {Button, Card, CardBody} from "reactstrap";
import "../../views/Authenticated/Transactions/transaction.css";
import "flag-icon-css/css/flag-icon.css";
import "../../views/Authenticated/Beneficiaries/beneficiaries.css"

export default class BeneficiaryCardBrowser extends Component {

    render() {
        return <Fragment>
            {this.renderBeneficiaryCards(this.props.beneficiary)}
        </Fragment>
    }

    renderBeneficiaryCards(beneficiary) {
        return <Fragment>
            <Card style={{border: "none"}}>
                <CardBody>
                    <div className={"beneficiary_card_header"}>
                        {this.renderHeader(beneficiary)}
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    }

    renderModalBeneficiaryCard(beneficiary) {
        return <Fragment>
            {this.renderHeader(beneficiary)}
            <br/>
            {this.renderBody()}
        </Fragment>

    }

    renderHeader(beneficiary) {
        return <Fragment>
            <div style={{display: "flex", flex: "4"}}>
                <div style={{display: "flex", width: "100%", flex: "1"}}>
                    <div className={"beneficiary_letter_div"}>
                        <div>
                            <div className={"beneficiary_letter_circle"}>
                                <span className={"beneficiary_letter"}>{beneficiary.beneficiaryLetter}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"beneficiary_card_beneficiary_container"}>
                        <div className={"beneficiary_card_beneficiary_name"}>
                            {beneficiary.beneficiaryName}
                        </div>
                    </div>
                </div>
                <div style={{display: "flex", width: "100%", textAlign: "right", flex: "3"}}>
                    <div className={"beneficiary_card_beneficiary_container"}>
                        <div className={"beneficiary_card_payout_partner"}>
                        </div>
                    </div>
                    <div className={"beneficiary_card_beneficiary_container"} style={{textAlign: "right"}}>
                        <div className={"beneficiary_card_payout_partner"}>
                            {beneficiary.countryName}
                        </div>
                        <span
                            className={"beneficiary_card_payout_partner"}>{beneficiary.payoutMethodName} - {this.props.beneficiary.payoutPartnerName}</span>
                    </div>
                </div>
            </div>
        </Fragment>
    }

    renderBody() {
        return <Fragment>
            <div style={{textAlign: "center"}}>
                <Button className={"beneficiary_card_send_money_button"}
                        onClick={() => this.props.onSendMoneyClick(this.props.beneficiary)}>Send Money Now</Button>
            </div>
        </Fragment>
    }

    getRandomColor() {
        let letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
}
